import { render, staticRenderFns } from "./MapDrawRectangle.vue?vue&type=template&id=56806b3e&"
import script from "./MapDrawRectangle.vue?vue&type=script&lang=js&"
export * from "./MapDrawRectangle.vue?vue&type=script&lang=js&"
import style0 from "./MapDrawRectangle.vue?vue&type=style&index=0&id=56806b3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports